import { render } from "./OrderRemake.vue?vue&type=template&id=3b5a3959&scoped=true"
import script from "./OrderRemake.vue?vue&type=script&lang=js"
export * from "./OrderRemake.vue?vue&type=script&lang=js"

import "./OrderRemake.vue?vue&type=style&index=0&id=3b5a3959&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5a3959"]])

export default __exports__